import { BlocksIconCalendarClock } from 'blocks-nextjs/blocks-web-components/components/icon/icons/calendar-clock';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCalendarClock = createComponent({ react: React, tagName: 'cat-icon-calendar-clock', elementClass: BlocksIconCalendarClock });
